import React, { useState } from 'react';
import './Footer.css';

const socialLabel = (item) => {
    // item can be a string id or an object: { id, type, socialMediaId, qrImgUrl }
    const raw = typeof item === 'string' ? item : (item && (item.type || item.id)) || '';
    const key = String(raw || '').toLowerCase();
    switch (key) {
        case 'wechat':
            return 'WeChat';
        case 'redbook':
        case 'xiaohongshu':
            return 'RedBook';
        case 'weibo':
            return 'Weibo';
        case 'telegram':
            return 'Telegram';
        default:
            return raw || 'QR';
    }
};

const Footer = ({ companyInfo = {} }) => {
    const [isQRExpanded, setIsQRExpanded] = useState(false);
    const year = new Date().getFullYear();
    const website = companyInfo.website || companyInfo.webUrl || '';
    const socials = Array.isArray(companyInfo.availableSocialMediaIds)
        ? companyInfo.availableSocialMediaIds.slice(0, 3)
        : [];

    return (
        <footer className="footer bg-dark text-white">
            <div className="footer-inner">
                <div className="container">
                    {/* Contact & QR */}
                    <div className="row align-items-start mt-3 gy-3">
                        <div className="col-12 col-md-3">
                            <div className={`qr-cards d-flex gap-3 ${isQRExpanded ? 'expanded' : 'collapsed'}`}>
                                {socials.length > 0 ? (
                                    socials.map((entry, idx) => {
                                        const label = socialLabel(entry);
                                        const key = typeof entry === 'object' ? (entry.id || entry.type || idx) : (entry || idx);
                                        const imgSrc = (typeof entry === 'object' && entry.qrImgUrl)
                                            ? entry.qrImgUrl
                                            : `https://placehold.co/100x100/png?text=${encodeURIComponent(label)}`;
                                        // On desktop, only show first or all if expanded; on mobile, CSS will show all
                                        const isVisible = idx === 0 || isQRExpanded;
                                        return (
                                            <div 
                                                className={`qr-card text-center ${isVisible ? '' : 'qr-card-hidden'}`} 
                                                key={String(key)}
                                            >
                                                <img
                                                    src={imgSrc}
                                                    alt={`${label} QR`}
                                                    className="qr-img"
                                                />
                                                <div className="qr-label">{label}</div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <>
                                        <div className="qr-card text-center">
                                            <img src="https://placehold.co/100x100/png?text=QR1" alt="QR Code 1" className="qr-img" />
                                            <div className="qr-label">QR 1</div>
                                        </div>
                                        <div className="qr-card text-center">
                                            <img src="https://placehold.co/100x100/png?text=QR2" alt="QR Code 2" className="qr-img" />
                                            <div className="qr-label">QR 2</div>
                                        </div>
                                    </>
                                )}
                            </div>
                            {socials.length > 1 && (
                                <button
                                    className="qr-expand-btn"
                                    onClick={() => setIsQRExpanded(!isQRExpanded)}
                                    aria-label={isQRExpanded ? '收起' : '展開'}
                                    title={isQRExpanded ? '收起' : '展開所有'}
                                >
                                    <i className={`fas fa-chevron-${isQRExpanded ? 'up' : 'down'}`}></i>
                                </button>
                            )}
                        </div>
                        <div className="col-12 col-md-9">
                            <ul className="list-unstyled mb-0 footer-contact text-start">
                                <li>
                                    客服熱線: {companyInfo.chinaCustomerServiceNo || '—'} (中國); {companyInfo.hkCustomerServiceNo || '—'} (中國香港)
                                </li>
                                <li>
                                    服務郵箱: {companyInfo.email1 || '—'}; {companyInfo.email2 || '—'}
                                </li>
                                <li>{companyInfo.chinaAddress || '—'}</li>
                                <li>{companyInfo.hkAddress || '—'}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom text-center">
                    <p className="small-text mb-0">
                        Copyright {year} &copy; LY Education Technology. 網站: {website ? (
                            <a href={website} target="_blank" rel="noopener noreferrer" className="footer-link text-white">
                                {website}
                            </a>
                        ) : (
                            '—'
                        )} 未書面授權禁止覆制或者建立鏡像
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;